import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { SnackbarProvider } from 'notistack';
import { Button, CircularProgress, CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
// import { BrowserRouter } from 'react-router-dom';
import { ReduxRouter } from '@lagunovsky/redux-react-router';
import { GoogleOAuthProvider } from '@react-oauth/google';
import theme from '../../theme';
import App from '../App/loadable';
import LanguageProvider from '../LanguageProvider';
import configureStore from '../../configureStore';
import history from '../../utils/history';
import { initStore } from '../../api';

const initialState = {};
const store = configureStore(initialState, history);
initStore(store);

const notistackRef = React.createRef();
const onClickDismiss = (key) => () => {
  notistackRef.current.closeSnackbar(key);
};

function Boot() {
  return (
    <Provider store={store}>
      <LanguageProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <SnackbarProvider
            ref={notistackRef}
            action={(key) => (
              <Button
                style={{ color: '#eeeeee' }}
                onClick={onClickDismiss(key)}
              >
                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: 'absolute',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <HighlightOffIcon sx={{ width: '16px' }} />
                  </Box>
                  <CircularProgress color='inherit' size={24} />
                </Box>
              </Button>
            )}
            hideIconVariant
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            autoHideDuration={3000}
          >
            <GoogleOAuthProvider clientId='576201594272-g4ft98f92a0g6a3gib5299feati6v31m.apps.googleusercontent.com'>
              <ReduxRouter history={history} store={store}>
                <App></App>
              </ReduxRouter>
            </GoogleOAuthProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </LanguageProvider>
    </Provider>
  );
}

export default Boot;
